import React from "react";
import * as S from "../css/NvrRun.styles";
import MenuComponent from "../component/MenuComponent";

function Edit(props) {

  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = 'https://jhcfile.jhcon.net/file/Vass_Pro_Downloader/vass_pro_downloader_1.0.0.zip'; // 다운로드할 파일 경로
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  return (
    <S.DashboardContainer>
      <MenuComponent theme={props.theme} />
      <S.ContentContainer>
        <h1>Vass NVR 프로그램을 실행합니다!</h1>
        <h4>프로그램이 켜지지 않을 시에는 프로그램이 정상적으로 설치되었는지 확인해주세요!</h4>
        <S.DownloadButton onClick={handleDownload}>
          Vass NVR 실행프로그램 다운로드
        </S.DownloadButton>
      </S.ContentContainer>
    </S.DashboardContainer>
  );
}

export default Edit;
